const uploadFileHelper = (resource) => {
  switch (resource) {
    case 'packages': return ['productIcon']
    case 'packageTemplates': return ['productIcon']
    case 'products': return ['previewImage', 'icon']
    case 'offers': return ['smallIcon', 'productIcon', 'titleBackground']
    default: return []
  }
}

export default uploadFileHelper



// WEBPACK FOOTER //
// ./src/uploadFileHelper.js